import React from 'react';

import { CliveAvatar } from '~/components/Clive/CliveAvatar';
import Text from '~/components/core/TextComponents/Text';

interface SopProcessingLoaderProps {
  message?: string;
}

const SopProcessingLoader: React.FC<SopProcessingLoaderProps> = ({ message = 'Processing...' }) => {
  return (
    <div className="flex flex-col items-center justify-start gap-12">
      <CliveAvatar mood={CliveAvatar.MOOD.LOADING} size={44} />
      <Text variant={Text.VARIANTS.XS}>{message}</Text>
    </div>
  );
};

export default SopProcessingLoader;
